import type { ErrorInfo, PropsWithChildren } from 'react';
import React, { Component } from 'react';
import { ErrorPage } from './ErrorPage';

interface ErrorBoundaryProps extends PropsWithChildren {}

interface ErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	state: ErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(_: Error): ErrorBoundaryState {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(_: Error, __: ErrorInfo) {
		// You can also log the error to an error reporting service
	}

	render() {
		// @TODO Implement for native app
		if (this.state.hasError) {
			return <ErrorPage message="ErrorBoundary catch error" />;
		}

		return this.props.children;
	}
}
